export default __webpack_public_path__ + "static/media/vuzop.212d43de.ogv";